import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getThemes, saveOrganization, uploadLogoFile } from '../../../actions/organization';
import { FILE_STORAGE_GOOGLE } from '../../../constants';
import { uuid } from '../../../helpers/common';
import { FormValidator } from '../../../helpers/form-validator';
import { validateOrganizationForm } from '../utils';

const OrganizationContext = React.createContext();

export const useOrganization = () =>
    useContext(OrganizationContext);

export const OrganizationProvider = ({ children }) => {
    const organization = useSelector(state => state.organization);
    const farm_uuid = useSelector(state => state.farm.currentFarm.farm_uuid);

    const [isRequesting, setIsRequesting] = useState(true);
    const [isUpdateRequesting, setIsUpdateRequesting] = useState(false);

    const intitalState = () => {
        const formValidator = new FormValidator([]);
        return {
            organizationName: '',
            uiConfig: {},
            themeId: 1,
            isSubmitted: false,
            validator: formValidator,
            validation: formValidator.valid()
        }
    }

    const [organizationState, setOrganizationState] = useState(intitalState());
    const [themeConfigData, setThemeConfigData] = useState([]);
    const dispatch = useDispatch();

    // bind initial state
    useEffect(() => {
        if (organization.isRequesting) return;
        const { uiConfig, organizationName, themeId } = organization;
        setOrganizationState({
            ...organizationState,
            uiConfig,
            organizationName,
            themeId
        });
    }, [organization]);

    useEffect(() => {
        setIsRequesting(true);
        dispatch(getThemes((themes) => {
            setThemeConfigData(themes);
            setIsRequesting(false);
        }))
    }, []);

    const handleReset = () => {
        const { uiConfig, organizationName, themeId } = organization;
        setOrganizationState({
            ...organizationState,
            uiConfig,
            organizationName,
            themeId
        });
    };


    const handleOrganizationSave = () => {
        const { file, uiConfig, themeId, organizationName, validator } = organizationState;

        const validation = validateOrganizationForm(validator, { organizationName });
        setOrganizationState({
            ...organizationState,
            validation,
            isSubmitted: true
        });
        if (!validation.isValid) return;

        const { organizationId } = organization;
        const handleOrganization = (data) => {
            const config = (data && data.url) ? { ...uiConfig, logoUrl: `${data.url}?v=${uuid()}` } : uiConfig;
            const updatedOrganizationParams = {
                farm_uuid,
                organization_uuid: organizationId,
                ui_config: config,
                theme_id: themeId,
                organization_name: organizationName
            };
            dispatch(saveOrganization(updatedOrganizationParams, true, () => setIsUpdateRequesting(false)));
        }

        setIsUpdateRequesting(true);
        if (file && file.file) {
            const selectedFile = file;
            let fileExtension = selectedFile.name.split('.').pop();
            dispatch(uploadLogoFile({
                ...selectedFile,
                storage: FILE_STORAGE_GOOGLE,
                name: `${organizationId}.${fileExtension}`,
            }, handleOrganization));
        } else {
            handleOrganization();
        }
    }


    const value = {
        isRequesting,
        isUpdateRequesting,
        themeConfigData,
        organizationState,
        setOrganizationState,
        handleOrganizationSave,
        handleReset
    };

    return (
        <OrganizationContext.Provider value={value}>
            {children}
        </OrganizationContext.Provider>
    )
}
